import script from "./ModifyHistModal.vue?vue&type=script&setup=true&lang=js"
export * from "./ModifyHistModal.vue?vue&type=script&setup=true&lang=js"

import "./ModifyHistModal.vue?vue&type=style&index=0&id=6d4462cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d4462cc"]])

export default __exports__